export enum PaymentStatus {
  COLLECTED = 'collected',
  OVERDUE = 'overdue',
  PENDING = 'pending',
  CANCELED = 'canceled',
  REFUNDED = 'refunded'
}
